function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import ReactDOM from 'react-dom';
import React from 'react';
import { loaderOpacity, loaderBackgroundStyle, spinner } from './views/Spinner';
import { WDHComponent } from '../../../../../../../wdh-foundation/wdh';
import Loader from "react-loader-advanced";
import ApiClient from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/api/api-client';
import ModalDialog from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/modal-dialog';
import TranslationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager';
import { TranslationKeys } from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const';
var WDHBillToSellToSpot = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHBillToSellToSpot() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bill-to-sell-to-spot';
    _classCallCheck(this, WDHBillToSellToSpot);
    return _callSuper(this, WDHBillToSellToSpot, [className]);
  }
  _inherits(WDHBillToSellToSpot, _WDHComponent);
  return _createClass(WDHBillToSellToSpot, [{
    key: "init",
    value: function init(component) {
      var settings = this.getSettingsFromComponent(component);
      ReactDOM.render(/*#__PURE__*/React.createElement(BillToSellToSpot, {
        settings: settings.data.items
      }), component.querySelector('.component-content'));
    }

    /**
     * Get the rendered settings for the component instance given by *component*
     * @param component
     * @private
     */
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[type="application/json"]');
      var settings = {};
      var newSetting = {};
      try {
        settings = JSON.parse(settingsElement.textContent);
        var billTos = settings.data.items.billToSellToList;
        billTos.map(function (billTo) {
          if (!newSetting[billTo.billToId]) {
            newSetting[billTo.billToId] = billTo;
            newSetting[billTo.billToId].sellTos = [];
          }
          newSetting[billTo.billToId].sellTos.push({
            sellToId: billTo.sellToId,
            sellToLabel: billTo.sellToLabel,
            isDefault: billTo.isDefault
          });
        });
        var arr = Object.values(newSetting);
        settings.data.items.newBTST = arr;
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }
      return settings;
    }
  }]);
}(WDHComponent);
export default WDHBillToSellToSpot;
var BillToSellToSpot = /*#__PURE__*/function (_React$Component) {
  function BillToSellToSpot(props) {
    var _this;
    _classCallCheck(this, BillToSellToSpot);
    _this = _callSuper(this, BillToSellToSpot, [props]);
    // set initial state
    _this.state = {
      items: [],
      billToAccounts: _this.props.settings.newBTST,
      sellToAccounts: _this.props.settings.newBTST.sellTos,
      selectedNewSellTo: _this.props.settings.defaultSellToId,
      showApplyButton: false,
      show: false,
      BTidFromDropdown: _this.props.settings.defaultBillToId,
      STidFromDropdown: _this.props.settings.defaultSellToId,
      BTLabelFromDropdown: '',
      STLabelFromDropdown: '',
      BTDropdownShow: false,
      STDropdownShow: false,
      toggleArrowBT: false,
      toggleArrowST: false,
      showAppliedPromotionCouponModal: false
    };
    _this.translations = {
      removeAppliedPromotionCouponWarning: TranslationManager.getTranslation('AppliedPromotionCouponWarning'),
      okText: TranslationManager.getTranslation(TranslationKeys.SHARED_OK),
      cancelText: TranslationManager.getTranslation(TranslationKeys.SHARED_CANCEL)
    };

    // Getting default BT ST labels
    for (var i = 0; i < _this.props.settings.newBTST.length; i++) {
      if (_this.props.settings.newBTST[i].billToId === _this.props.settings.defaultBillToId) {
        _this.state.BTLabelFromDropdown = _this.props.settings.newBTST[i].billToLabel;
        for (var j = 0; j < _this.props.settings.newBTST[i].sellTos.length; j++) {
          if (_this.props.settings.newBTST[i].sellTos[j].sellToId === _this.props.settings.defaultSellToId) {
            _this.state.STLabelFromDropdown = _this.props.settings.newBTST[i].sellTos[j].sellToLabel;
          }
        }
      }
    }
    _this.handleBTSelect = _this.handleBTSelect.bind(_this);
    _this.handleBTChange = _this.handleBTChange.bind(_this);
    _this.handleSTSelect = _this.handleSTSelect.bind(_this);
    _this.handleSTChange = _this.handleSTChange.bind(_this);
    _this.onApplyButtonClick = _this.onApplyButtonClick.bind(_this);
    _this.billtoSearchBox = _this.billtoSearchBox.bind(_this);
    _this.selltoSearchBox = _this.selltoSearchBox.bind(_this);
    return _this;
  }
  _inherits(BillToSellToSpot, _React$Component);
  return _createClass(BillToSellToSpot, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "handleBTSelect",
    value: function handleBTSelect(e) {
      this.setState({
        BTDropdownShow: !this.state.BTDropdownShow,
        toggleArrowBT: !this.state.toggleArrowBT,
        STDropdownShow: false
      });
    }
  }, {
    key: "handleBTChange",
    value: function handleBTChange(e, index) {
      var _this2 = this;
      var e1 = document.querySelector('#BTSelector' + index);
      this.state.billToAccounts.forEach(function (account) {
        if (account.billToId === e1.dataset.billtoid) {
          _this2.setState({
            sellToAccounts: account.sellTos,
            STidFromDropdown: account.sellTos[0].sellToId
          });
        }
      });
      this.setState({
        showApplyButton: true,
        BTidFromDropdown: e1.dataset.billtoid,
        BTLabelFromDropdown: e1.dataset.billtolabel,
        BTDropdownShow: false
      });
    }
  }, {
    key: "handleSTSelect",
    value: function handleSTSelect(e) {
      this.setState({
        STDropdownShow: !this.state.STDropdownShow,
        toggleArrowST: !this.state.toggleArrowST,
        BTDropdownShow: false
      });
    }
  }, {
    key: "handleSTChange",
    value: function handleSTChange(e, index) {
      var e1 = document.querySelector('#STSelector' + index);
      this.setState({
        selectedNewSellTo: e.target.value,
        STidFromDropdown: e1.dataset.selltoid,
        STLabelFromDropdown: e1.dataset.selltolabel,
        showApplyButton: true,
        STDropdownShow: false
      });
    }
  }, {
    key: "onApplyButtonClick",
    value: function onApplyButtonClick(e) {
      var _this3 = this;
      e.preventDefault();
      ApiClient.cart.checkPromotionOrCouponApplied().then(function (response) {
        if (response) {
          _this3.setState({
            showAppliedPromotionCouponModal: true
          });
        } else {
          var baseBTSTURl = '/webservices/account.svc/toggleaccount/',
            success = true;
          var BTSTResultURL = baseBTSTURl + _this3.state.BTidFromDropdown + "/" + _this3.state.STidFromDropdown;
          _this3.setState({
            show: true
          });
          $.ajax({
            url: BTSTResultURL,
            type: 'GET'
          }).then(function (data, textState, jqXHR) {
            switch (jqXHR.status) {
              case 200:
                window.location.reload(true);
                break;
              default:
                break;
            }
          });
        }
        return response;
      }).catch(function (error) {
        return _this3.showError(_this3.translations.errorMessage, "An error occurred while applying promotion -> ".concat(JSON.stringify(error)), error);
      });
    }
  }, {
    key: "billtoSearchBox",
    value: function billtoSearchBox(e) {
      var input, filter, BTOptionbox, BTOptionList, a, i, txtValue;
      input = document.getElementById("BTSearchbox");
      filter = input.value.toUpperCase();
      BTOptionbox = document.getElementById("BTOption");
      BTOptionList = BTOptionbox.getElementsByTagName("div");
      for (i = 0; i < BTOptionList.length; i++) {
        a = BTOptionList[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          BTOptionList[i].style.display = "";
        } else {
          BTOptionList[i].style.display = "none";
        }
      }
    }
  }, {
    key: "selltoSearchBox",
    value: function selltoSearchBox(e) {
      var input, filter, STOptionbox, STOptionList, a, i, txtValue;
      input = document.getElementById("STSearchbox");
      filter = input.value.toUpperCase();
      STOptionbox = document.getElementById("STOption");
      STOptionList = STOptionbox.getElementsByTagName("div");
      for (i = 0; i < STOptionList.length; i++) {
        a = STOptionList[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          STOptionList[i].style.display = "";
        } else {
          STOptionList[i].style.display = "none";
        }
      }
    }
  }, {
    key: "removAppliedPromotionCoupon",
    value: function removAppliedPromotionCoupon() {
      var _this4 = this;
      ApiClient.cart.removeAppliedPromotionCoupon(this.state.BTidFromDropdown, this.state.STidFromDropdown).then(function (response) {
        _this4.setState({
          showAppliedPromotionCouponModal: false
        });
        var baseBTSTURl = '/webservices/account.svc/toggleaccount/',
          success = true;
        var BTSTResultURL = baseBTSTURl + _this4.state.BTidFromDropdown + "/" + _this4.state.STidFromDropdown;
        _this4.setState({
          show: true
        });
        $.ajax({
          url: BTSTResultURL,
          type: 'GET'
        }).then(function (data, textState, jqXHR) {
          switch (jqXHR.status) {
            case 200:
              window.location.reload(true);
              break;
            default:
              break;
          }
        });
      }).catch(function (error) {
        return _this4.showError(_this4.translations.errorMessage, "An error occurred while applying promotion -> ".concat(JSON.stringify(error)), error);
      });
    }
  }, {
    key: "handleDeleteAppliedPromotionCouponCancel",
    value: function handleDeleteAppliedPromotionCouponCancel() {
      this.setState({
        showAppliedPromotionCouponModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      // ST Filter
      var BTSTList = this.props.settings.newBTST.filter(function (BTSTList) {
        return BTSTList.billToId === _this5.state.BTidFromDropdown;
      });
      //Adding input search for both BT and ST
      var btinputField, stinputField;
      $('.bt.optionDiv div').length > 5 ? btinputField = /*#__PURE__*/React.createElement("input", {
        id: "BTSearchbox",
        type: "text",
        placeholder: "Search for Bill to...",
        onKeyUp: function onKeyUp(e) {
          return _this5.billtoSearchBox(e);
        }
      }) : btinputField = '';
      $('.st.optionDiv div').length > 5 ? stinputField = /*#__PURE__*/React.createElement("input", {
        id: "STSearchbox",
        type: "text",
        placeholder: "Search for Sell to...",
        onKeyUp: function onKeyUp(e) {
          return _this5.selltoSearchBox(e);
        }
      }) : stinputField = '';
      // Apply button
      var applyWrapper;
      this.state.showApplyButton === true ? applyWrapper = /*#__PURE__*/React.createElement("a", {
        className: "button dark-bg",
        onClick: this.onApplyButtonClick
      }, "Apply") : applyWrapper = /*#__PURE__*/React.createElement("a", {
        className: "button dark-bg inactive"
      }, "Apply");
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.showAppliedPromotionCouponModal,
        type: ModalDialog.types.okCancel,
        onOkClick: function onOkClick(event) {
          return _this5.removAppliedPromotionCoupon();
        },
        okLabel: this.translations.okText,
        onCancelClick: function onCancelClick(event) {
          return _this5.handleDeleteAppliedPromotionCouponCancel();
        },
        cancelLabel: this.translations.cancelText
      }, /*#__PURE__*/React.createElement("p", null, this.translations.removeAppliedPromotionCouponWarning)), /*#__PURE__*/React.createElement(Loader, {
        show: this.state.show,
        message: spinner,
        contentBlur: loaderOpacity,
        backgroundStyle: loaderBackgroundStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "BTSTWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "BTWrapper"
      }, /*#__PURE__*/React.createElement("span", {
        className: "BTSTLabel"
      }, "*Bill To:"), /*#__PURE__*/React.createElement("div", {
        className: this.state.toggleArrowBT === true ? 'selectDiv open' : 'selectDiv',
        onClick: function onClick(e) {
          return _this5.handleBTSelect(e);
        }
      }, this.state.BTidFromDropdown, " : ", this.state.BTLabelFromDropdown), /*#__PURE__*/React.createElement("div", {
        id: "BTOption",
        className: this.state.BTDropdownShow === true ? 'bt optionDiv active' : 'bt optionDiv'
      }, btinputField, this.props.settings.newBTST.map(function (billTos, i) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: billTos.billToId
        }, /*#__PURE__*/React.createElement("div", {
          id: "BTSelector" + i,
          "data-value": billTos.billToId,
          key: billTos.billToId,
          "data-billtoid": billTos.billToId,
          "data-billtolabel": billTos.billToLabel,
          onClick: function onClick(e) {
            return _this5.handleBTChange(e, i);
          }
        }, /*#__PURE__*/React.createElement("a", {
          href: "#"
        }, /*#__PURE__*/React.createElement("span", {
          className: "billtoselltoID"
        }, billTos.billToId), " : ", /*#__PURE__*/React.createElement("span", {
          className: "billtoselltoLabel"
        }, billTos.billToLabel))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "STWrapper"
      }, /*#__PURE__*/React.createElement("span", {
        className: "BTSTLabel"
      }, "*Sell To:"), /*#__PURE__*/React.createElement("div", {
        className: this.state.toggleArrowST === true ? 'selectDiv sellTo open' : 'selectDiv sellTo',
        onClick: function onClick(e) {
          return _this5.handleSTSelect(e);
        }
      }, this.state.STidFromDropdown, " : ", this.state.STLabelFromDropdown), /*#__PURE__*/React.createElement("div", {
        id: "STOption",
        className: this.state.STDropdownShow === true ? 'st optionDiv active' : 'st optionDiv'
      }, stinputField, BTSTList[0].sellTos.map(function (sellToItems, i) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: sellToItems.sellToId
        }, /*#__PURE__*/React.createElement("div", {
          id: "STSelector" + i,
          "data-value": sellToItems.sellToId,
          key: sellToItems.sellToId,
          "data-selltoid": sellToItems.sellToId,
          "data-selltolabel": sellToItems.sellToLabel,
          onClick: function onClick(e) {
            return _this5.handleSTChange(e, i);
          }
        }, /*#__PURE__*/React.createElement("a", {
          href: "#"
        }, /*#__PURE__*/React.createElement("span", {
          className: "billtoselltoID"
        }, sellToItems.sellToId), " : ", /*#__PURE__*/React.createElement("span", {
          className: "billtoselltoLabel"
        }, sellToItems.sellToLabel))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "applyBtnWrapper"
      }, applyWrapper))));
    }
  }]);
}(React.Component);